<template>
    <div class="todo-table table-list">
        <div class="table-list-title">
            <span class="category">分類</span>
            <span class="description">待辦敘述</span>
        </div>
        <div class="table-list-body">
            <div v-show="loopLimit.length == 0" class="is-empty">0 筆資料</div>
            <ul>
                <li v-for="(item, index) in loopLimit" :key="index" @click="$router.push({name: 'bizLeaseMgtDefault', query: {complete: 'noCompleted'}})">
                    <span class="category">{{transTodoListCat(item.category)}}</span>
                    <span v-if="item.category == 'ADD_BILL'" >{{item.address}}，應繳日{{getFormatDateTime(item.eventDate)}}還沒新增帳單</span>
                    <span v-if="item.category == 'ARREARS'" >{{item.address}}，應繳日{{getFormatDateTime(item.eventDate)}}還沒繳費</span>
                    <span v-if="item.category == 'DUE_REMINDER'" >{{item.address}}，{{getFormatDateTime(item.eventDate)}}租約到期</span>
                    <span v-if="item.category == 'NOT_EVALUATE'" >{{item.address}}租約已結束，請評價房客</span>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { apiBizGetTodoListLease } from "@/apis/api.js"; 

export default {
    data () {
        return {
            list: ''
        }
    },
    mounted () {
        this.getTodoListLease()
    },
    props: {
        limit: false 
    },
    watch: {
        filterQuery: {
            handler: function () {
                this.getTodoListLease()
            },
            deep: true
        }
    },
    methods: {
        getTodoListLease : function () {
            let data = {
                county: this.filterQuery.county,
                district: this.filterQuery.district,
                groupId: this.filterQuery.groupId,
                memberId: this.filterQuery.memberId
            }

            apiBizGetTodoListLease(data)
            .then(res => {
                console.log(res)
                if( res.data.status == 'SUCCESS'){
                    this.list = res.data.result
                }
            })
            .catch(err => {
                console.log(err)
            })
        },
    },
    computed: {
        loopLimit: function () {
            if(this.limit){
                return this.list.slice(0, this.limit)
            }else{
                return this.list
            }
        },
        ...mapGetters({
            filterQuery: 'BIZ_TODO_LIST_FILTER_QUERY',
        })
    }
}
</script>
<style lang="scss" scoped>
    .todo-table{
        &.table-list{
            width: 100%;
            border-radius: 0;
            border-left: none;
            border-right: none;
            border-bottom: none;
            box-sizing: border-box;
            .table-list-body ul li{
                cursor: pointer;
            }
        }
        .category{
            width: 76px;
            margin-right: 60px;
        }
        .description{
            width: 250px;
            margin-right: 60px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/personalHome/home/todoList/todoLease.vue